//A tag utilizada aqui é apenas uma forma de identificar por string o retorno do ocr
export const DOCUMENTO_OCR_CATEGORIA = {
	DOCUMENTO_PESSOAL: { id: 5003, tag: 'documento-pessoal' },
	COMPROVANTE_RESIDENCIA: { id: 3, tag: 'comprovante-residencia' },
	HOLERITE: { id: 5000, tag: 'holerite' },
	CPF: { id: 1, tag: 'cpf' },
	CNH: { id: 2, tag: 'cnh' },
	RG: { id: 4, tag: 'rg' }
}

export const DOCUMENTO_TYPE_OCR_TAGS = {
	/* Comprovante residencia */
	COMPROVANTE_RESIDENCIA: 'comprovante-residencia',
	COMPROVANTE_RESIDENCIA2: 'comprovante_residencia',
	BOLETO: 'boleto',
	BOLETO_LUZ: 'boleto-luz',
	GAS: 'of=gas',
	FATURA: 'fatura',
	FATURA2: 'type=fatura',
	SABESP: 'bra-agua-sabesp-1',
	WATER: 'of=water',
	BILL: 'std-type=bill',

	/* Documento Pessoal */
	DOCUMENTO_PESSOAL: 'documento-pessoal',
	DOCUMENTO_PESSOAL2: 'documento_pessoal',
	DOCUMENTO_IDENTIFICACAO: 'documento_identificacao',
	RG: 'rg',
	RG_FRENTE: 'rg_frente',
	RG_VERSO: 'rg_verso',

	CPF: 'cpf',
	CNH: 'cnh',
	CNH_FRENTE: 'cnh_frente',
	CNH_VERSO: 'cnh_verso',
	BRA_CNH_1: 'bra-cnh-1',

	TITULO_ELEITOR: 'titulo-eleitor',
	BRA_TITULO_ELEITOR_1: 'bra-titulo-eleitor-1',

	CERTIDAO_CASAMENTO: 'certidao-casamento',
	BRA_CERTIDAO_CASAMENTO_1: 'bra-certidao-casamento-1',
	MARRIAGE: 'of=marriage',

	/* Holerite */
	HOLERITE: 'holerite',
	INSS: 'inss',
	SOCIAL_SECURITY: 'social-security',
	HISCON: 'hiscon',
	CREDIT_HISTORY: 'credit-history',
	PREVIDENCIA_HISTORICO_DE_CREDITOS_1: 'bra-previdencia-historico-de-creditos-1',
	CONTRACHEQUE: 'contracheque',
	COMPROVANTE_CONTRA_CHEQUE: 'comprovante-contra-cheque',
	PROLABORE: 'prolabore',
	EXTRATO_BANCARIO: 'extrato-bancario',
	BRA_CONTRACHEQUE_1: 'bra-contracheque-1',
	BRA_CONTRACHEQUE_3: 'bra-contracheque-3',
	BRA_CONTRACHEQUE_2: 'bra-contracheque-2',
	BRA_CONTRACHEQUE_5: 'bra-contracheque-5',
	BRA_CONTRACHEQUE_6: 'bra-contracheque-6',
	BRA_CONTRACHEQUE_7: 'bra-contracheque-7',
	BRA_CONTRACHEQUE_8: 'bra-contracheque-8',

	/* IMPOSTO RENDA */
	EXTRATO: 'extrato',
	IMPOSTO_RENDA: 'imposto_renda',
	EXTRATO_IR: 'extrato-ir',
	BRA_IMPOSTO_RENDA_1: 'bra-imposto-renda-1',
	INCOME_TAX: 'of=income-tax',

	RECIBO: 'recibo',
	REGISTER: 'goal=register',
	IMPOSTO_RENDA2: 'of=imposto-renda',

	FORMULARIO: 'formulario',
	BRA_CADASTRO_CNPJ_1: 'bra-cadastro-cnpj-1',
	PERSON_LEGAL: 'person=legal'
}

/**
 * Retorna o id da categoria do documento pela tag do ocr
 * @returns Array
 */
export function getCategoriaDocumentoIdByTipo(tipoDocumento: string): number {
	switch (tipoDocumento) {
		case DOCUMENTO_TYPE_OCR_TAGS.COMPROVANTE_RESIDENCIA:
		case DOCUMENTO_TYPE_OCR_TAGS.COMPROVANTE_RESIDENCIA2:
		case DOCUMENTO_TYPE_OCR_TAGS.BOLETO:
		case DOCUMENTO_TYPE_OCR_TAGS.BOLETO_LUZ:
		case DOCUMENTO_TYPE_OCR_TAGS.GAS:
		case DOCUMENTO_TYPE_OCR_TAGS.FATURA:
		case DOCUMENTO_TYPE_OCR_TAGS.FATURA2:
		case DOCUMENTO_TYPE_OCR_TAGS.SABESP:
		case DOCUMENTO_TYPE_OCR_TAGS.WATER:
		case DOCUMENTO_TYPE_OCR_TAGS.BILL:
			return DOCUMENTO_OCR_CATEGORIA.COMPROVANTE_RESIDENCIA.id

		case DOCUMENTO_TYPE_OCR_TAGS.DOCUMENTO_PESSOAL:
		case DOCUMENTO_TYPE_OCR_TAGS.DOCUMENTO_PESSOAL2:
		case DOCUMENTO_TYPE_OCR_TAGS.DOCUMENTO_IDENTIFICACAO:
		case DOCUMENTO_TYPE_OCR_TAGS.RG:
		case DOCUMENTO_TYPE_OCR_TAGS.RG_FRENTE:
		case DOCUMENTO_TYPE_OCR_TAGS.RG_VERSO:
		case DOCUMENTO_TYPE_OCR_TAGS.CPF:
		case DOCUMENTO_TYPE_OCR_TAGS.CNH:
		case DOCUMENTO_TYPE_OCR_TAGS.CNH_FRENTE:
		case DOCUMENTO_TYPE_OCR_TAGS.CNH_VERSO:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CNH_1:
		case DOCUMENTO_TYPE_OCR_TAGS.TITULO_ELEITOR:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_TITULO_ELEITOR_1:
		case DOCUMENTO_TYPE_OCR_TAGS.CERTIDAO_CASAMENTO:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CERTIDAO_CASAMENTO_1:
		case DOCUMENTO_TYPE_OCR_TAGS.MARRIAGE:
			return DOCUMENTO_OCR_CATEGORIA.DOCUMENTO_PESSOAL.id

		case DOCUMENTO_TYPE_OCR_TAGS.HOLERITE:
		case DOCUMENTO_TYPE_OCR_TAGS.INSS:
		case DOCUMENTO_TYPE_OCR_TAGS.SOCIAL_SECURITY:
		case DOCUMENTO_TYPE_OCR_TAGS.HISCON:
		case DOCUMENTO_TYPE_OCR_TAGS.CREDIT_HISTORY:
		case DOCUMENTO_TYPE_OCR_TAGS.PREVIDENCIA_HISTORICO_DE_CREDITOS_1:
		case DOCUMENTO_TYPE_OCR_TAGS.CONTRACHEQUE:
		case DOCUMENTO_TYPE_OCR_TAGS.COMPROVANTE_CONTRA_CHEQUE:
		case DOCUMENTO_TYPE_OCR_TAGS.PROLABORE:
		case DOCUMENTO_TYPE_OCR_TAGS.EXTRATO_BANCARIO:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CONTRACHEQUE_1:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CONTRACHEQUE_3:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CONTRACHEQUE_2:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CONTRACHEQUE_5:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CONTRACHEQUE_6:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CONTRACHEQUE_7:
		case DOCUMENTO_TYPE_OCR_TAGS.BRA_CONTRACHEQUE_8:
			return DOCUMENTO_OCR_CATEGORIA.HOLERITE.id
	}

	return 0
}

export function documentFilter(documentType: number): number {
	switch (documentType) {
		case DOCUMENTO_OCR_CATEGORIA.CPF.id:
		case DOCUMENTO_OCR_CATEGORIA.CNH.id:
		case DOCUMENTO_OCR_CATEGORIA.RG.id:
			return DOCUMENTO_OCR_CATEGORIA.DOCUMENTO_PESSOAL.id
	}

	return documentType
}
